import {
  LandingPage,
  SearchableVerticalList,
  SearchableVerticalListDataType,
} from '@tyrio/ui-library';

import api from '@tyrio/api-factory';
import { DBAdminApi } from '@tyrio/dto';
import { tyrioIcons } from '@tyrio/ui-library';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import { pageSize } from '../../../../constants/pagination.constants';
import { useDebounce } from '../../hooks/useDebounce';
import { ExpandableLayout } from '../../layouts/ExpandableLayout';
import routeNames from '../../lib/routeNames';

interface DashboardAdminProps {
  children: React.ReactNode;
}

const DashboardAdmin = ({ children }: DashboardAdminProps) => {
  const history = useHistory();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebounce(search, 500);
  const location = useLocation();

  const { isFetching, isError, data } = useQuery(
    ['admin_list', { debouncedSearch, page }],
    () => searchAdmins(search, page),
    {}
  );

  const [selected, setSelected] = useState<Record<string, boolean>>(
    location.pathname.split('/').pop() !== 'admin'
      ? { [location.pathname.split('/').pop()]: true }
      : {}
  );
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClick = (type: string, item?: any) => {
    Object.keys(selected).forEach((key) => {
      selected[key] = false;
    });
    if (type === 'itemClicked') {
      setSelected((prevValue) => ({
        ...prevValue,
        [item.id]: !prevValue[item.id],
      }));
      history.push(`/dashboard/admin/${item.id}`);
    }
    if (type === 'new') {
      history.push(`/dashboard/admin/new`);
    }
  };

  const searchAdmins = async (search: string, page: number) => {
    return await api.fetch<DBAdminApi['list']>('admins', {
      isUserIncluded: true,
      isRoleIncluded: true,
      search: search,
      page: page,
      pageSize: pageSize,
    });
  };

  return (
    <ExpandableLayout
      sidebarComponent={
        <SearchableVerticalList
          header="Admin Users"
          type={SearchableVerticalListDataType.WITHOUT_CHILDREN}
          data={
            data?.data.map((item) => ({
              id: item.id,
              name: [item?.user?.firstName, item?.user?.lastName].join(' '),
              type: item?.user?.role?.roleName.toUpperCase(),
              active: item.active,
              disabled: !item.active,
              isSelected: selected[item.id],
            })) || []
          }
          path={routeNames.dashboard()}
          isFetching={isFetching}
          isError={isError}
          onSearchChange={setSearch}
          onCreateNew={() => handleClick('new', {})}
          handleItemClick={(item) => handleClick('itemClicked', item)}
          onChangePage={(page) => setPage(page)}
          pageNumber={page}
          count={data?.count}
        />
      }
      landingPage={
        <LandingPage
          icon={tyrioIcons.adminIcon}
          title={'Welcome to Admin settings'}
          subtitle={'Choose admin from the list or create new.'}
          cyId={'create-new-admin-landing'}
          buttonText={'Add new admin'}
          onClick={() => handleClick('new', {})}
        />
      }
    >
      {children}
    </ExpandableLayout>
  );
};

export default DashboardAdmin;
